import { Box } from "@mui/material";
import RentalStepper from "../RentalStepper";
import { useStepper } from "../../../common/Providers/StepperProvider/useStepper";

interface SplitLayoutProps {
  children: React.ReactNode;
  rightContent: React.ReactNode;
  showStepper?: boolean;
}

const SplitLayout: React.FC<SplitLayoutProps> = ({ children, rightContent, showStepper = true }) => {
  const { steps, activeStep } = useStepper();

  const stepperSteps = steps.filter((step: any) => !step.hideInStepper);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.leftContent}>
        {showStepper && <RentalStepper steps={stepperSteps} activeStep={activeStep} />}
        {children}
      </Box>
      <Box sx={styles.rightContent}>{rightContent}</Box>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
  },
  leftContent: {
    flex: 1,
  },
  rightContent: {
    width: "100%",
    flex: "0 0 296px", // fixed width on larger screens
    position: {
      xs: "static",
      md: "sticky",
    },
    top: {
      xs: 0,
      md: 4,
    },
    alignSelf: "flex-start", // ensures sticky respects parent container
  },
};
export default SplitLayout;
